import React, { FunctionComponent } from "react";
import styles from "../css/Section3.module.css";
import picField from "../../assets/pic_field.png";
import { useSelector } from "react-redux";
import { Quotes } from "../../svg_groups/quotes";

const Section3 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.quote}>
        <span className={styles.desiredAction}>
          {language === "EN" && (
            <>
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                <div
                  style={{ position: "absolute", left: "-25px", top: "-15px" }}
                >
                  <Quotes />
                </div>
                Big dreams
              </span>{" "}
              need freedom to flourish
              <span
                style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}
              ></span>{" "}
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                Invest
              </span>{" "}
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                in what truly matters to your soul.
                <span className={styles.quotes2}>
                  <Quotes />
                </span>
                <div style={{ position: "absolute", left: "-25px" }}></div>
              </span>{" "}
            </>
          )}
          {language === "RO" && (
            <>
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                <div
                  style={{ position: "absolute", left: "-25px", top: "-15px" }}
                >
                  <Quotes />
                </div>
                Visurile mari
              </span>{" "}
              au nevoie de{" "}
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                libertate
              </span>{" "}
              pentru a înflori. Investește în&nbsp;
              <span style={{ color: "#c4b57c", fontFamily: "Lora, serif" }}>
                ceea ce contează cu adevărat pentru sufletul tău.
                <span className={styles.quotes2}>
                  <Quotes />
                </span>
              </span>
            </>
          )}{" "}
          {language === "RU" && "Книга которая"}{" "}
        </span>
      </div>
      <span className={styles.mostWanted}>
        {language === "EN" &&
          "Big dreams need freedom to flourish. Invest in what truly matters to your soul."}
        {language === "RO" &&
          "Visurile mari au nevoie de libertate pentru a înflori. Investește în ceea ce contează cu adevărat pentru sufletul tău."}
      </span>
      <img src={picField} />
    </div>
  );
};

export default Section3;
